import type { App } from 'vue';
import { Button } from './Button';
import VXETable from 'vxe-table';
import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx';
import VXETablePluginAntd from 'vxe-table-plugin-antd';
import VXETablePluginMenus from 'vxe-table-plugin-menus';
import { Input, Layout } from 'ant-design-vue';
import '/@/vxe-helpers/plugins/vxe-table-pro.es6.min';
import '/@/vxe-helpers/plugins/vxe-table-pro.min.css';
import 'vxe-table-plugin-antd/dist/style.css';

VXETable.use(VXETablePluginExportXLSX).use(VXETablePluginAntd).use(VXETablePluginMenus);

export function registerGlobComp(app: App) {
  app.use(Input).use(VXETable).use(Button).use(Layout);
}
